import React, { useState, useContext } from 'react';
import axios from 'axios';
import styles from './ResetPassword.module.css';
import logo1 from "../../assets/logo1.png";
import { LanguageContext } from "../LanguageContext/LanguageContext";

const ResetPasswordForm = () => {
  const { direction } = useContext(LanguageContext);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Get the token from the URL
    const token = new URLSearchParams(window.location.search).get('token');


    const newPassword = event.target.newPassword.value;
    const confirmPassword = event.target.confirmPassword.value;

    if (newPassword !== confirmPassword) {
      const errorMsg = direction === "rtl" ? 'كلمات المرور غير متطابقة' : 'Passwords do not match';
      setError(errorMsg);
      return;
    }

    if (!token) {
      const errorMsg = direction === "rtl" ? 'المستخدم غير مصادق عليه' : 'User is not authenticated';
      setError(errorMsg);
      return;
    }

    try {
      const response = await axios.post(
        `${marketingBackendUrl}/maflam/reset-password`, 
        { 
          token: token, 
          newPassword: newPassword 
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      const successMsg = direction === "rtl" ? 'تم تغيير كلمة المرور بنجاح' : response.data.message;
      setMessage(successMsg);
      alert(successMsg);
    } catch (error) {
      const errorMsg = direction === "rtl" 
        ? 'خطأ في إعادة تعيين كلمة المرور' 
        : error.response?.data?.message || 'Error resetting password';
      setError(errorMsg);
    }
  };

  return (
    <div className={styles.maincontainer} style={{ direction }}>
      <div className={styles.secondcontainer}>
        <header className={styles.header}>
          <img src={logo1} alt="resetlogo" className={styles.resetlogo} />
          <h1>{direction === "rtl" ? "تغيير كلمة المرور" : "Change Password"}</h1>
        </header>

        <form className={styles.form} onSubmit={handleSubmit}>
          <label htmlFor="newPassword">
            {direction === "rtl" ? "كلمة المرور الجديدة" : "New Password"}
          </label>
          <input 
            type="password" 
            id="newPassword"
            name="newPassword" 
            placeholder={direction === "rtl" ? "أدخل كلمة المرور الجديدة" : "Enter new password"}
            className={styles.input}
            required 
          />

          <label htmlFor="confirmPassword">
            {direction === "rtl" ? "تأكيد كلمة المرور" : "Confirm Password"}
          </label>
          <input 
            type="password" 
            id="confirmPassword"
            name="confirmPassword" 
            placeholder={direction === "rtl" ? "تأكيد كلمة المرور الجديدة" : "Confirm new password"}
            className={styles.input}
            required 
          />

          {error && <p className={styles.error}>{error}</p>}
          {message && <p style={{ color: '#39FFFB', marginBottom: '15px' }}>{message}</p>}

          <button 
            type="submit" 
            className={styles.submitButton}
          >
            {direction === "rtl" ? "تغيير كلمة المرور" : "Change Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
